import { HubComparison } from '../components/HubComparison'

export function HubCompare() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Hub Comparison</h1>
        <p className="text-eve-muted text-sm">
          Para los items top de tu hangar: ¿Jita, Amarr, Dodixie, Rens o Hek
          paga más ahora mismo? Comparamos el mejor buy order en cada hub.
        </p>
      </div>

      <HubComparison />
    </div>
  )
}
